import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1b927d08")

_pushScopeId("data-v-1b927d08")
const _hoisted_1 = /*#__PURE__*/_createVNode("h5", null, "Sms History", -1)
const _hoisted_2 = {
  key: 0,
  class: "green"
}
const _hoisted_3 = {
  key: 1,
  class: "red"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_DataTable, {
      value: _ctx.rows,
      stripedRows: "",
      responsiveLayout: "scroll"
    }, {
      default: _withId(() => [
        _createVNode(_component_Column, {
          field: "id",
          class: "vertAlign",
          header: "Id"
        }),
        _createVNode(_component_Column, {
          class: "smg-text",
          field: "message",
          header: "Message"
        }, {
          body: _withId(({ data }) => [
            _createVNode("div", {
              innerHTML: data.message
            }, null, 8, ["innerHTML"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "mobile",
          class: "vertAlign",
          header: "Mobile"
        }),
        _createVNode(_component_Column, {
          field: "createdAt",
          class: "vertAlign",
          header: "Created At"
        }, {
          body: _withId(({ data }) => [
            _createTextVNode(_toDisplayString(_ctx.getDateFormat(data.createdAt)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "status",
          class: "vertAlign",
          header: "Status"
        }, {
          body: _withId(({ data }) => [
            (data.status)
              ? (_openBlock(), _createBlock("span", _hoisted_2, "Sent"))
              : (_openBlock(), _createBlock("span", _hoisted_3, "Not sent"))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"])
  ]))
})